import { useHistory } from 'react-router-dom';
import { Media } from 'reactstrap';

export function Growl({ type, contract, from, id, who, translated }) {
    const history = useHistory();

    const handleGoTo = () => {
        if (id) {
            history.push(`/contracts/editor/${id}`)
        }
    }

    return (
        <Media onClick={handleGoTo}>
            <Media className="align-self-center">
                <img src='/images/owl-logo.svg' height="50px" alt="logo"></img>
            </Media>
            <Media className="ml-2 align-self-center">
                {who}{who && ' - '}
                {translated}{' '}
                {typeof contract === "string" ? contract : contract?.name }
            </Media>
        </Media>
    )
}